import { MetricConfig } from '../config/chartConfig';

interface MetricTogglePillsProps {
  availableMetrics: string[];
  selectedMetrics: string[];
  onMetricsChange: (metrics: string[]) => void;
  metricConfigs: Record<string, MetricConfig>;
  minSelected?: number;
  maxSelected?: number;
}

export const MetricTogglePills = ({
  availableMetrics,
  selectedMetrics,
  onMetricsChange,
  metricConfigs,
  minSelected = 1,
  maxSelected = 3,
}: MetricTogglePillsProps) => {
  const handleToggle = (metric: string) => {
    const isSelected = selectedMetrics.includes(metric);

    if (isSelected && selectedMetrics.length <= minSelected) return;
    if (!isSelected && selectedMetrics.length >= maxSelected) return;

    const updated = isSelected
      ? selectedMetrics.filter(m => m !== metric)
      : [...selectedMetrics, metric];

    onMetricsChange(updated);
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {availableMetrics.map(metric => {
        const config = metricConfigs[metric];
        if (!config) return null;
        const isSelected = selectedMetrics.includes(metric);

        return (
          <button
            key={metric}
            type="button"
            onClick={() => handleToggle(metric)}
            className={`rounded-full px-3 py-0.5 text-xs font-medium transition-all ${
              isSelected
                ? 'text-white shadow-sm'
                : 'bg-[var(--anl-surface-elev)] text-[var(--anl-text)] hover:opacity-90'
            }`}
            style={{ backgroundColor: isSelected ? config.color : undefined }}
          >
            {config.label}
          </button>
        );
      })}
    </div>
  );
};
